import CustomImage from "../image/CustomImage";
import { Column, Row, SizedBox } from "../CommonBaseComponents";
import CustomText, { C3Text } from "../text/CustomText";
import CustomProgressBar from "./CustomProgressBar";
import { Theme } from "../../Theme";

export default function DeviceActiveProgressBar({ type = "washer", total = 4, active = 2 }) {
    let text;
    let progressColor;

    if (type === "washer") {
        text = "Washer";
        progressColor = Theme.color.blue600;
    } else if (type === "dryer") {
        text = "Dryer";
        progressColor = Theme.color.orange500;
    } else if (type === "combo") {
        text = "Combo";
        progressColor = Theme.color.indigo500;
    }

    return (
        <Row width={"100%"} height={"52px"}>
            <CustomImage imageName={`image_${type}`} width={"29px"} height={"36px"} />
            <SizedBox width={"16.25px"} />
            <Column flex={"1"}>
                <Row justifyContent={"space-between"} width={"100%"}>
                    <C3Text fontWeight={"400"} fontColor={Theme.color.gray500}>
                        {text}
                    </C3Text>
                    <Row>
                        <CustomText fontSize={"14px"} fontWeight={"700"} fontColor={Theme.color.zinc850}>
                            {active.toString()}
                        </CustomText>
                        <CustomText fontSize={"14px"} fontWeight={"400"} fontColor={Theme.color.zinc850}>
                            /{total.toString()}
                        </CustomText>
                    </Row>
                </Row>
                <SizedBox height={"6px"} />
                <CustomProgressBar total={total} active={active} activeColor={progressColor} />
            </Column>
        </Row>
    );
}
